module.exports = __webpack_public_path__ + "img/icon-profitable.8d7fe8ca.svg";